// Where an owner lands (spec/13 §13.1, F-HQ-03): an owner whose organisation has not opened a venue yet — none at all,
// or every one still setting up — opens the console on that organisation's Setup, after accepting their invitation and
// every time after, until a venue goes live. Anyone else lands where they always have. Read from what the console
// already holds (`GET /v1/me/organizations`, `GET /v1/me/venues`), so the decision costs no request of its own.

import type { MyOrganization, MyVenue } from '../api/me';

/** Whether the member holds the built-in owner role there. better-auth keeps a comma list; a custom role is never it. */
export function isOwnerRole(role: string | undefined): boolean {
  return role !== undefined && role.split(',').some((part) => part.trim() === 'owner');
}

/** Has any of the organisation's venues opened for business (live, or paused after it was)? */
export function organizationHasOpened(organizationId: string, venues: readonly MyVenue[]): boolean {
  return venues.some((venue) => venue.organizationId === organizationId && (venue.status === 'live' || venue.status === 'paused'));
}

/** The first organisation the member owns that has not opened a venue yet: where they land. `undefined`: land as usual. */
export function setupLandingFor(organizations: readonly MyOrganization[], venues: readonly MyVenue[]): MyOrganization | undefined {
  return organizations.find((organization) => isOwnerRole(organization.role) && !organizationHasOpened(organization.id, venues));
}
